export default __webpack_public_path__ + "static/media/4ac4830f0a245c1740d86447a5d63b62.jpg";